import React from 'react';
export function EmotionalTransition() {
  return <section className="py-16 px-4 bg-brand-green text-brand-cream text-center" data-id="element-35">
      <div className="max-w-3xl mx-auto space-y-6" data-id="element-36">
        <p className="text-xl md:text-2xl font-playfair italic" data-id="element-37">
          Y lo más frustrante es que muchas veces intentás mejorar tu
          alimentación, hacer ejercicio o dormir mejor… pero nada parece
          funcionar como antes.
        </p>

        <div className="w-16 h-px bg-brand-gold mx-auto my-8" data-id="element-38"></div>

        <p className="text-lg md:text-xl font-medium" data-id="element-39">
          La realidad es que muchas de estas señales no tienen que ver con falta
          de disciplina.
        </p>

        <p className="text-2xl md:text-3xl font-bold text-brand-gold leading-tight" data-id="element-40">
          Tienen que ver con desequilibrios hormonales que afectan cómo funciona
          tu cuerpo.
        </p>

        <p className="text-lg md:text-xl text-brand-cream/90" data-id="element-41">
          Cuando tus hormonas no están en equilibrio, tu metabolismo cambia, tu
          energía baja y tu cuerpo empieza a reaccionar de formas que antes no
          pasaban.
        </p>
      </div>
    </section>;
}